<div class="contractWrapper" #parser></div>
<div class="flex gap-x-10 w-per100 justify-center items-center">
    <button *ngIf="showSave" class="action darkButton" (click)="saveDocument()">Save Document</button>
    <button class="darkOutlineButton action" (click)="downloadAsPDF()">Download</button>
</div>